import { axiosGet } from '@/api/handlers';

export const fetchProject = async (id: string): Promise<any> => {
  return await axiosGet(`/api/projects/${id}/`);
};
